/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { FC } from 'react';
import styles from './infoBox.module.scss';
import ReactCountryFlag from 'react-country-flag';
import countries from 'i18n-iso-countries';

interface Field {
  title: string;
  value: React.ReactNode;
}

interface InfoBoxProps {
  picture?: string;
  valueStyleTaxonomy?: boolean;
  countryCode?: string;
  item?: Field | null;
  subItem?: Field | null;
  identifier?: string | number;
  customStyle?: {
    minWidth?: string;
    box?: string;
    title?: string;
    value?: React.CSSProperties;
  };
  overwriteStyle?: React.CSSProperties;
}

const InfoBox: FC<InfoBoxProps> = (props) => {
  const { picture, countryCode, item, valueStyleTaxonomy, subItem, identifier, customStyle, overwriteStyle = {} } = props;

  const countryCodeIso2 = countryCode ? countries.alpha3ToAlpha2(countryCode.toUpperCase()) : undefined;

  return (
    <div className={styles.box + ' ' + customStyle?.box} style={overwriteStyle}>
      <table>
        <tbody>
          {countryCodeIso2 &&
            <tr>
              <td className={styles.tdFlag}>
                <div className={styles.flagContainer}>
                  <ReactCountryFlag
                    style={{fontSize: '1.5em'}}
                    countryCode={countryCodeIso2}
                    title={countryCodeIso2}
                    svg
                  />
                </div>
              </td>
            </tr>}
          {picture &&
            <tr>
              <td>
                <img src={picture} className={styles.picture} id={`${identifier}-picture`} />
              </td>
            </tr>}
          {item !== undefined &&
            <tr className={styles.fieldContainerItem}>
              <td>
                <div className={styles.field}>
                  <div id={`${identifier}-title`} className={styles.title + ' ' + customStyle?.title} style={valueStyleTaxonomy ? { color: 'rgb(255, 0, 0)', fontWeight: 700 } : {}}>{item?.title}</div>
                  <div id={`${identifier}-value`} className={styles.value} style={customStyle?.value}>{item?.value}</div>
                </div>
              </td>
            </tr>}
          {subItem !== undefined &&
            <tr className={styles.fieldContainerSubitem}>
              <td>
                <div className={styles.field}>
                  <div id={`${identifier}-title`} className={styles.title + ' ' + customStyle?.title}>{subItem?.title}</div>
                  <div id={`${identifier}-value`} className={styles.value}>{subItem?.value}</div>
                </div>
              </td>
            </tr>}
        </tbody>
      </table>
    </div>
  );
};

export default InfoBox;
